import { Box, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { invoicedTabPagingTabAPICall } from '../../jobcardInvoices/services/apiCall';
import CardView from '../../proprietaryWarranty/pages/proprietaryCardView';
var InvoicedTab = function () {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var columns = [{
            field: 'InvoiceNo',
            headerName: 'Invoiced no.',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoiceDate',
            headerName: 'Invoiced date',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'CustomerName',
            headerName: 'Customer name',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'CustomerNo',
            headerName: 'Customer no.',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoicedAmount',
            headerName: 'Invoiced amount',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'OustandingAmount',
            headerName: 'Outstanding amount',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'PaymentMode',
            headerName: 'Payment mode',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'PaymentMethod',
            headerName: 'Payment method',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'PaymentStatus',
            headerName: 'Payment status',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'Executive',
            headerName: 'Executive',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'CreatedBy',
            headerName: 'Created by',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoiceStatus',
            headerName: 'Status',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoiceAction',
            headerName: '',
            minWidth: 150,
            editable: false,
            flex: 1
        }];
    return isMobile ? /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        isReadyForInvoiceTitle: true,
        isCreateReturn: true,
        isMenuIcon: false,
        pagingApiCall: invoicedTabPagingTabAPICall,
        pagingKey: 'demo',
        pagingRequest: {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
        },
        pageSize: 20,
        cardMapper: function (data) {
            var _data$InvoiceDate;
            return {
                id: "card-".concat(data === null || data === void 0 ? void 0 : data.id),
                docNo: data !== null && data !== void 0 && data.RegistrationNo ? data === null || data === void 0 ? void 0 : data.RegistrationNo : '-',
                title: data !== null && data !== void 0 && data.InvoiceDate ? dayjs((_data$InvoiceDate = data === null || data === void 0 ? void 0 : data.InvoiceDate) !== null && _data$InvoiceDate !== void 0 ? _data$InvoiceDate : '').format('DD MMM, YYYY') : '-',
                statusName: data === null || data === void 0 ? void 0 : data.JobCardStatusName,
                details: [{
                        label: "Customer :",
                        value: data === null || data === void 0 ? void 0 : data.CustomerName
                    }, {
                        label: "Customer number:",
                        value: data === null || data === void 0 ? void 0 : data.CustomerNo
                    }, {
                        label: "Invoice amount:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceAmount
                    }, {
                        label: "Outstanding amount:",
                        value: data === null || data === void 0 ? void 0 : data.OutstandingAmount
                    }, {
                        label: "Payment mode:",
                        value: data === null || data === void 0 ? void 0 : data.PaymentMode
                    }, {
                        label: "Payment status:",
                        value: data === null || data === void 0 ? void 0 : data.PaymentStatus
                    }, {
                        label: "Executive :",
                        value: data === null || data === void 0 ? void 0 : data.Executive
                    }, {
                        label: "Created by:",
                        value: data === null || data === void 0 ? void 0 : data.CreatedBy
                    }]
            };
        }
    })) : /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        dataGridProps: {
            disableColumnMenu: true,
            initialState: {
                pinnedColumns: {
                    right: ['InvoiceAction']
                }
            }
        }
    });
};
export default InvoicedTab;
